/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rail_OutsideInputs */

const en_rail_outside = /** @type {(inputs: Rail_OutsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outside`)
};

/**
* | output |
* | --- |
* | "Outside" |
*
* @param {Rail_OutsideInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const rail_outside = /** @type {((inputs?: Rail_OutsideInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rail_OutsideInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_rail_outside(inputs)
});